export default {
  writedown: '#36312E',
  writedownDark: '#100903',
  gray: '#E1E2E1',
  grayLight: '#F5F5F6',
  white: '#fafafa',
  black: '#333',
  codeBg: '#364549',
  codeFont: '#C5C8C6',
}
